import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setWaitCampaign } from '../../_redux/actions/campaign';

import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar';
import { ReactComponent as LogoYalo } from '../../img/logo-yalo.svg';
import { ReactComponent as LogoDrConsulta } from '../../img/dr-consulta2.svg';
import logoTheNail from '../../img/logo-thenail.svg';
import logoConsulta from '../../img/dr-consulta2.svg';
import farmacias2 from '../../img/drogaraia-drogasil.png';
import DrogasilDrogaRaia from '../../img/drogasil--drogaraia.png';

import stores from '../../utils/stores';
import Loading from '../../Components/Loading';
import WhatsAppBtn from '../../Components/WhatsAppBtn';

import { campaignUtils } from '../../utils';
import { PageView, initGA } from '../../Components/Tracking';

import './index.scss';
class HomeTheNail extends Component {
	componentWillMount() {
		if (campaignUtils.checkExist(this.props.location.search)) {
			let campaignData = campaignUtils.getData();
			this.props.setWaitCampaign(campaignData);
		}
	}
	componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;

			$('.drc-carousel').slick({
				centerPadding: '30px',
				infinite: false,
				arrows: false,
				dots: true
			});
			$('.discounts-carousel').slick({
				centerPadding: '30px',
				infinite: false,
				arrows: false,
				dots: true,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 992,
						settings: 'unslick'
					}
				]
			});
			$('[data-toggle="tooltip"]').tooltip();
			$(window).on('load', function() {
				$('#coronaModal').modal('show');
			});
		}
		initGA();
		PageView('/loja/thenail');

		sessionStorage.setItem('store', stores.theNail);
	}
	render() {
		const RouteSidebar = withRouter(props => <Sidebar {...props} />);
		return (
			<div className='page-wrapper'>
				<Loading></Loading>
				<div className='container-fluid'>
					<div className='row'>
						<div className='col-xs-12 col-md-9 landing'>
							<section className='section featured thenail'>
								<div className='container-fluid'>
									<div className='row visible-xs visible-sm header'>
										<div className='col-xs-3'>
											<a
												href='https://yalo.com.br'
												className='hidden-md hidden-lg logomobile'>
												<LogoYalo
													className='img-responsive'
													width={50}
													height={50}></LogoYalo>
											</a>
										</div>
										<div className='col-xs-9 text-center'>
											<h4 className='f-bold'>A assinatura da saúde!</h4>
										</div>
									</div>
									<div className='row'>
										<div className='col-xs-12'>
											<div className='logoTheNail'>
												<img src={logoTheNail} width='430' alt='logonail' />
											</div>
										</div>
									</div>

									<div className='row'>
										<div className='col-xs-12 col-md-7 center-mobile'>
											<h2>
												O programa de assinatura
												<br />
												do
												<span className='logo-drconsultawhite'>
													{' '}
													dr<span>.</span>consulta
												</span>
												,
												<br />
												feito para manicures,
												<br />
												agora com consultas online.
											</h2>
										</div>
									</div>

									{/* Inicio Slider */}
									<div className='row visible-xs visible-sm mt-5'>
										<div className='col-xs-offset-1 col-xs-10'>
											<div className='drc-carousel'>
												<div className='drc-box-new'>
													<div className='drc-box--content-new'>
														<h2 className='text-center'>
															<img
																src={logoConsulta}
																className='imgbox'
																alt=''
																srcset=''
															/>
															{/* <LogoDrConsulta
																alt='dr.consulta'
																className='svg-consulta'></LogoDrConsulta> */}
															<br />
															Consulta presencial e online por apenas{' '}
															<strong className='f-black'>R$ 40</strong> com
															retorno gratuito em até 30 dias e
															<strong className='f-black'> 20%</strong> de
															desconto em exames.
														</h2>
													</div>
												</div>
												<div className='drc-box-new'>
													<div className='drc-box--content-new'>
														<h2 className='text-center'>
															<img
																src={DrogasilDrogaRaia}
																className='imgbox'
																alt=''
															/>{' '}
															<br />
															<strong className='f-black'>15%</strong> de
															desconto em medicamentos <br />
															tarjados, genéricos e de marca.
															<br />
														</h2>
													</div>
												</div>
											</div>
										</div>
									</div>
									{/* Fim Slider */}

									<div className='row visible-md visible-lg'>
										<div className='col-xs-12 col-md-4 space-box'>
											<div className='drc-box-new'>
												<div className='drc-box--content-new'>
													<h2 className='text-center'>
														<LogoDrConsulta
															alt='dr.consulta'
															className='svg-consulta'></LogoDrConsulta>
														<br />
														Consulta presencial e online por apenas{' '}
														<strong className='f-black'>R$ 40</strong> com
														retorno gratuito em até 30 dias e
														<strong className='f-black'> 20%</strong> de
														desconto em exames.
													</h2>
												</div>
											</div>
										</div>
										<div className='col-xs-12 col-md-4 align-center space-box'>
											<div className='drc-box-new'>
												<div className='drc-box--content-new'>
													<h2 className='text-center'>
														<img
															src={DrogasilDrogaRaia}
															className='imgbox'
															alt=''
														/>{' '}
														<br />
														<strong className='f-black'>15%</strong> de desconto{' '}
														em medicamentos <br />
														tarjados, genéricos e de marca.
														<br />
													</h2>
												</div>
											</div>
										</div>
									</div>
								</div>
							</section>

							<section className='section-diferenca-corona'>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-md-12'>
											<h2 className='f-black' id='mais-saude'>
												Com você, no momento que mais precisa
											</h2>
											<h3 className='f-black'>
												Estamos aqui para te ajudar durante o coronavírus
											</h3>
										</div>
									</div>
									<div className='row'>
										<div className='col-12 col-md-10'>
											<ul>
												<li>
													<p className='f-regular'>
														Todas as consultas <strong>online</strong> por{' '}
														<strong>R$40</strong>, para seu acompanhamento
													</p>
												</li>

												<li>
													<p className='f-regular'>
														Seja atendido de{' '}
														<strong>qualquer lugar do Brasil</strong>
													</p>
												</li>

												<li>
													<p className='f-regular'>
														Sua prescrição médica disponível no{' '}
														<strong>aplicativo</strong> do{' '}
														<span>dr.consulta</span>
													</p>
												</li>

												<li>
													<p className='f-regular'>
														Atendimento especial para{' '}
														<strong>dúvidas sobre o coronavírus</strong>
													</p>
												</li>

												<li>
													<p className='f-regular'>
														<strong>Psicologia</strong> e{' '}
														<strong>psiquiatria</strong> para acompanhamento
														durante período de quarentena
													</p>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</section>

							<section className='yalo-saude'>
								<div className='container-fluid'>
									<div className='row'>
										<div className='col-12 col-md-8 padding-top300'></div>
										<div className='col-12 col-md-4 center-mobile-price '>
											<h2>
												Yalo fidelidade <br /> <span>por apenas</span>
											</h2>
											<h3>
												<span>12x</span>27
												<strong className='price-cents'>,</strong>
												<strong className='price-cents-adm'>90</strong>
											</h3>
											<h4>
												e garanta mais
												<br />
												saúde para
												<br />a sua vida.
											</h4>
											<a
												href='/loja/thenail/beneficiario?assinatura=fidelidade'
												className='btn btn-orange'>
												Assine agora
											</a>
										</div>
									</div>
								</div>
							</section>

							<section className='diferenca-new'>
								<div className='container-fluid'>
									<div className='row text-center'>
										<div className='col-12'>
											<h2 className='f-black'>
												Economize em mais de 2.000 farmácias
											</h2>
										</div>
									</div>

									<div className='row text-center'>
										<div className='col-12'>
											<h3 className='desconto-economize-new'>15%</h3>
											<p className='text-economize-new'>
												de desconto em medicamentos tarjados,
												<br />
												genéricos e de marca
											</p>
										</div>
									</div>
									<div className='row text-center'>
										<div className='col-12'>
											<img src={farmacias2} className='img-new' alt='' />
										</div>
									</div>
								</div>
							</section>
							<footer className='footer'>
								{/*}
								<div className='container-fluid'>
									<div className='row footer-top'>
										<div className='col-12 col-md-6 col-lg-3'>
										<img
														src={logoYaloHorizontal}
														className='img'
														alt=''
													/>
											<p> <strong>CNPJ 28.757.895/0001-22</strong></p>
											<p className='f-light'> Copyright © 2020 - yalo</p>
											<p className='f-light'>	Todos os direitos reservados.  </p>
										</div>
										<div className='col-12 col-md-6 col-lg-3 link-contact'>
											<h3>&nbsp;</h3>
											<a href="tel:+4000-1664" className="icon-phone">Fale conosco: 4000-1664</a>
											<a href="https://api.whatsapp.com/send?phone=5511983120317" className="icon-whats">Vendas: (11) 98312-0317</a>
											<a href="https://api.whatsapp.com/send?phone=5511983120377" className="icon-whats">Atendimento: (11) 98312-0377</a>
											<a href="mailto:contato@yalo.com.br" ><i className="icon-mail"></i>contato@yalo.com.br</a>
										</div>
										<div className='col-12 col-md-6 col-lg-3'>
											<h3>&nbsp;</h3>
											<p>Horário de funcionamento:</p>
											<p>De segunda a sexta-feira, <br/>das 7h às 20h</p>
											<p>Exceto feriados</p>
										</div>
										<div className='col-12 col-md-6 col-lg-3'>
											<h3>&nbsp;</h3>
											<p>Siga a gente nas<br /> Redes Sociais</p>
											<ul className='icon-social'>
													<li><a href="https://www.facebook.com/yalobrasil" className='icon-facebook'>Facebook</a></li>
													<li><a href="https://www.instagram.com/yalobrasil/" className='icon-instagram'>Instagram</a></li>
													<li><a href="https://pt.linkedin.com/company/yalobrasil" className='icon-linkedin'>LinkedIn</a></li>
											</ul>
										</div>
									</div>
									<div className='row'>
										<div className='col-md-12'>
											<p className='juridic'> <small> OODONTOLOGIA: não incluso consultas, exames ou procedimentos. EXAMES: os descontos são aplicados apenas para exames realizados nos centros médicos próprios do dr.consulta. Não inclusos check-ups e pacotes. MICRO PROCEDIMENTOS E CIRURGIAS: Não estão inclusos</small></p>
											</div>
									</div>
									<div className='row'>
										<div className='col-xs-12'>
											<div className='utils'> <small>© 2020 yalo – Todos os direitos reservados |
												<a href='https://yalo.com.br/termos' target='_blank' rel='noopener noreferrer'>Termos e Condições do Site</a> |
												<a href='https://yalo.com.br/files/Politica_de_Privacidade_e_Seguranca_Yalo.951f98bf.pdf' target='_blank' rel='noopener noreferrer'>Política de Privacidade e Segurança</a> |
												<a href='https://yalo.com.br/contratos' target='_blank' rel='noopener noreferrer'>Contratos</a></small> </div>
										</div>
									</div>
								</div>*/}
								<div className='visible-md visible-lg last-message'></div>
							</footer>
						</div>
					</div>
				</div>
				<WhatsAppBtn
					phone='5511963309934'
					message='Oi+tudo+bem+você+poderia+me+ajudar?'
				/>
				<Link
					to='thenail/beneficiario?assinatura=fidelidade'
					className='f-bold button-sticky hidden-lg hidden-md mobile-sign'>
					Assinar agora!
				</Link>
				<RouteSidebar></RouteSidebar>
			</div>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign }, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(HomeTheNail);
